module.exports = __WEBPACK_EXTERNAL_MODULE__babylonjs_gui_2D_controls_image__;